/**
 * * Форматирование размера файла
 * @param sizeInBytes Размер в байтах
 * @returns
 */
export const formatFileSize = (sizeInBytes: number): string => {
  const units = ["Б", "КБ", "МБ", "ГБ"];
  let unitIndex = 0;

  let size = sizeInBytes;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  // Ограничиваем количество знаков после запятой до двух
  const formattedSize = parseFloat(size.toFixed(2));

  return `${formattedSize} ${units[unitIndex]}`;
};
